import React from "react";
import Modal from "../layout/Modal";
import Portal from "../layout/Portal";

class ModalEditor extends React.Component {

    state = {
        opened: false
    }

    focus = () => {
        //this.modal && this.modal.focus();
        this.setState({opened: true});
    }

    hide = () => {
        //this.modal && this.modal.hide();
        this.setState({opened: false});
    }

    onClose = async () => {
        this.props.pristineForm && await this.props.pristineForm();
        this.props.onClose && await this.props.onClose();
        this.hide();
    };

    render() {
        const props = {...this.props};
        //if (props.selection && props.selection[props.componentConfig.idfield] !== undefined) {
        //    props.state = "on";
        //}
        let children = React.Children.map(this.props.children, (child) => {
            if (child instanceof Function || child === null || child === undefined) {
                return child;
            }
            let childProps = {...child.props};
            if (childProps.loadForm) {
                childProps.loadForm = async (data) => {
                    this.focus();
                    return await childProps.loadForm(data);
                };
            }
            return <child.type {...childProps} />;
        });
        return (
            <Portal>
                <Modal
                    ref={(el) => this.modal = el}
                    size={this.props.modalSize || "large"}
                    state={this.state.opened ? "on" : "off"}
                    {...props}
                    disabled={props.disabled || props.isLoading}
                    buttons={[
                        {
                            text: "Bezárás",
                            props: {color: "default", disabled: props.disabled || props.isLoading},
                            onClose: true,
                            onClick: this.onClose
                        }
                ]}>
                    {children}
                </Modal>
            </Portal>
        );
    }

}

export default ModalEditor;